// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5q-2";
export var blackBorderOnHover = "_5q-7";
export var cell = "_5q-6";
export var cellContainer = "_5q-3";
export var checked = "_5q-8";
export var disabled = "_5q-5";
export var featuredIconCellContainer = "_5q-9";
export var featuredIconTextContainer = "_5q-b";
export var featuredIconWrapper = "_5q-a";
export var noBorder = "_5q-c";
export var orangeSelectedRow = "_cs-3";
export var overflowableText = "_5q-0";
export var overflowableTextContainer = "_5q-1";
export var row = "_5p-0";
export var rowCheckboxCell = "_5q-4";
export var selectableTable = "_cs-2";